import type { Priority, TaskStatus } from "./index";
import {
  getSnapshot,
  getCategoryLabel,
  getCategoryDotColor,
  getCategoryBarColor,
  getCategoryBlockColor,
  getCategoryTagColor,
} from "../stores/category-store";

// ---------------------------------------------------------------------------
// Dynamic category accessors — always reflect defaults + custom categories
// ---------------------------------------------------------------------------

/** All category ids (defaults + custom). Reads latest store snapshot. */
export function getCategories(): readonly string[] {
  return getSnapshot().categories;
}


/** Proxy-based dynamic records: accessing any key returns the correct value
 *  for both built-in and custom categories. */
export const CATEGORY_LABELS: Record<string, string> = new Proxy(
  {} as Record<string, string>,
  { get: (_t, key: string) => getCategoryLabel(key) },
);

export const CATEGORY_COLORS: Record<string, string> = new Proxy(
  {} as Record<string, string>,
  { get: (_t, key: string) => getCategoryTagColor(key) },
);

export const CATEGORY_DOT_COLORS: Record<string, string> = new Proxy(
  {} as Record<string, string>,
  { get: (_t, key: string) => getCategoryDotColor(key) },
);

export const CATEGORY_BAR_COLORS: Record<string, string> = new Proxy(
  {} as Record<string, string>,
  { get: (_t, key: string) => getCategoryBarColor(key) },
);

export const CATEGORY_BLOCK_COLORS: Record<string, string> = new Proxy(
  {} as Record<string, string>,
  { get: (_t, key: string) => getCategoryBlockColor(key) },
);

// ---------------------------------------------------------------------------
// Non-category constants (unchanged)
// ---------------------------------------------------------------------------

export const STATUS_LABELS: Record<TaskStatus, string> = {
  todo: "A faire",
  doing: "En cours",
  done: "Fait",
};

export const STATUS_CYCLE: Record<TaskStatus, TaskStatus> = {
  todo: "doing",
  doing: "done",
  done: "todo",
};

export const PRIORITY_LABELS: Record<Priority, string> = {
  urgent: "Urgent",
  normal: "Normal",
  low: "Bas",
};

export const PRIORITY_COLORS: Record<Priority, string> = {
  urgent: "text-danger",
  normal: "text-ink-muted",
  low: "text-ink-faint",
};

export const PRIORITY_ICONS: Record<Priority, string> = {
  urgent: "🔴",
  normal: "🟡",
  low: "⚪",
};
